import type { CheckoutBridgeService } from '@/scopes/checkout/domain/types/services/bridge'
import { produce } from 'immer'

interface BridgeServicePayload {
  checkedParticipantIds: string[]
  optionId: string
}

export function updateBridgeService(payload: BridgeServicePayload) {
  return produce((service: CheckoutBridgeService) => {
    Object.values(service.participants).forEach((participant) => {
      if (!participant.availableOptions.includes(payload.optionId))
        return

      const alreadySelected = participant.selectedValues.includes(payload.optionId)

      if (payload.checkedParticipantIds.includes(participant.id)) {
        if (!alreadySelected) {
          participant.selectedValues = [...participant.selectedValues, payload.optionId]
        }
      }
      else if (alreadySelected) {
        participant.selectedValues = participant.selectedValues.filter(v => v !== payload.optionId)
      }
    })
  })
}
